<template>
<div class="talent-level-container">
  <div class="list-wrap">
    <div class="block width-1 fleft">
      <button class="button is-success" @click="visible = true">创建推送</button>
    </div>
    <div class="fleft">
      <span>【白名单功能：</span>
      <span v-if="isUsingWhiteList">开启</span>
      <span v-else>关闭</span>
      <span>】</span>
    </div>
    <div class="fleft" v-if="isUsingWhiteList && whiteListUserIds.length>0">
      <span>【</span>
      <span v-for="(id,index) in whiteListUserIds"><a target="_blank" :href="'/admin.php?method=user.show&userId='+id">{{id}}</a><span v-if="whiteListUserIds.length-1!==index">、</span></span>
      <span>】</span>
    </div>
    <div class="fleft" v-if="canSetWhiteList">
      <a target="_blank" href="/admin.php?method=config.show&type=86">点击查看></a>
    </div>
    <div class="clearfix">
      <el-pagination @current-change="handleCurrentChange" :current-page="search.page" :page-size="search.pageSize" layout="total, prev, pager, next, jumper" :total="count" class="fright">
      </el-pagination>
    </div>
    <el-table :data="list" stripe border>
      <el-table-column prop="sendTime" label="发送时间" align="center"></el-table-column>
      <el-table-column prop="pushId" label="ID" align="center"></el-table-column>
      <el-table-column prop="name" label="活动名称" align="center"></el-table-column>
      <el-table-column prop="status" label="当前状态" align="center"></el-table-column>
      <el-table-column label="累计发送数(小程序/服务号)" align="center">
        <template slot-scope="scope">
          {{scope.row.sentMiniProgramCount}}/{{(scope.row.model == 4 || scope.row.model == 2) ? "无" : scope.row.sentServiceCount}}
        </template>
      </el-table-column>
      <el-table-column label="累计点击数(小程序/服务号)" align="center">
        <template slot-scope="scope">
          {{scope.row.miniProgramClickCount}}/{{(scope.row.model == 4 || scope.row.model == 2) ? "无" : scope.row.serviceClickCount}}
        </template>
      </el-table-column>
      <el-table-column label="点击用户数(小程序/服务号)" align="center">
        <template slot-scope="scope">
            {{scope.row.miniProgramClickUserCount}}/{{(scope.row.model == 4 || scope.row.model == 2) ? "无" : scope.row.serviceClickUserCount}}
        </template>
      </el-table-column>
      <el-table-column label="点击率(小程序/服务号)" align="center" width="160">
        <template slot-scope="scope">
          <span v-if="scope.row.sentMiniProgramCount>0">{{(scope.row.miniProgramClickUserCount/scope.row.sentMiniProgramCount*100).toFixed(2)}}%／</span>
          <span v-else><span v-if="scope.row.sentMiniProgramCount=='无'">无/</span><span v-else>0.00%/</span></span>
          <span v-if="scope.row.sentServiceCount>0">{{(scope.row.serviceClickUserCount/scope.row.sentServiceCount*100).toFixed(2)}}%</span>
          <span v-else><span v-if="scope.row.sentServiceCount=='无' || (scope.row.model == 4 || scope.row.model == 2)">无</span><span v-else>0.00%</span></span>
        </template>
      </el-table-column>

      <el-table-column label="关联拼团ID" align="center">
        <template slot-scope="scope">
          <a v-for="(link, index) in scope.row.relatedGroupBuyId" :href="hostName+'/m/page/goods_groupon/index.html?groupBuyId='+link" target="_blank">
            {{link}}
            <span v-if="index!== scope.row.relatedGroupBuyId.length-1">，</span>
          </a>
        </template>
      </el-table-column>
      <el-table-column prop="operatorName" label="操作人" align="center"></el-table-column>
      <el-table-column label="操作" align="center" width="100">
        <template slot-scope="scope">
          <el-popover
            @show='showPopover(scope.row.pushId, scope.row.model)'
            ref="popover{{$index}}"
            placement="right-start"
            width="300"
            trigger="hover">
            <div class="template-message">
              <div v-if='templateMessage.title' class='title'>{{templateMessage.title}}</div>
              <div v-for="(item,index) in templateMessage.list" class="content">
                <span v-if='item.name'>{{item.name}}</span>
                <span v-if='index!=templateMessage.list.length-1' :style="{'color': item.color}">{{item.value}}</span>
                <textarea v-if='index==templateMessage.list.length-1' :style="{'color': item.color}">{{item.value}}</textarea>
              </div>
            </div>
          </el-popover>
          <i v-if="scope.row.status == '未推送'" @click="removePush(scope.row.pushId)" class="el-icon-delete" ></i>
          <i class="el-icon-view" v-popover:popover{{$index}}></i>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix">
      <el-pagination @current-change="handleCurrentChange" :current-page="search.page" :page-size="search.pageSize" layout="total, prev, pager, next, jumper" :total="count" class="fright">
      </el-pagination>
    </div>
  </div>
  <el-dialog title="创建推送" :visible.sync="visible" width="55%">
    <el-form label-position="right" label-width="100px">
      <el-form-item label="选择模板">
        <el-radio-group v-model="model" @change='changeModel'>
          <el-radio :label="1">报名成功通知</el-radio>
          <el-radio :label="4">活动加入成功提醒</el-radio>
          <el-radio :label="2">已关注商品降价</el-radio>
          <el-radio :label="3">活动即将开始</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="发送时间">
        <el-date-picker v-model="modal.sendTime" type="datetime" format="yyyy-MM-dd HH:mm" placeholder="选择日期时间">
        </el-date-picker>
      </el-form-item>
      <template v-if='model==1'>
        <el-form-item label="活动名称">
          <el-input style="width: 220px;" v-model="modal.name"></el-input>
        </el-form-item>
        <el-form-item label="关联拼团ID">
          <el-input style="width: 220px;" :rows="4" type="textarea" v-model="modal.relatedGroupBuyId" placeholder="多个拼团ID换行输入"></el-input>
        </el-form-item>
      </template>
      <template v-if='model==2'>
        <el-form-item label="商品名称">
          <el-input style="width: 220px;" v-model="modal.goodsName"></el-input>
        </el-form-item>
        <el-form-item label="商品价格">
          <el-input style="width: 220px;" :rows="4" v-model="modal.goodsPrice" ></el-input>
        </el-form-item>
        <el-form-item label="关联拼团ID">
          <el-input style="width: 220px;" :rows="4" type="textarea" v-model="modal.relatedGroupBuyId" placeholder="多个拼团ID换行输入"></el-input>
        </el-form-item>
      </template>
      <template v-if='model==3'>
        <el-form-item label="首句">
          <el-input style="width: 220px;" v-model="modal.firstWords"></el-input>
        </el-form-item>
        <el-form-item label="主题">
          <el-input style="width: 220px;" v-model="modal.theme"></el-input>
        </el-form-item>
        <el-form-item label="时间">
          <el-input style="width: 220px;" v-model="modal.time" placeholder="请输入时间"></el-input>
        </el-form-item>
        <el-form-item label="尾句">
          <el-input style="width: 220px;" v-model="modal.lastWords"></el-input>
        </el-form-item>
        <el-form-item label="跳转链接">
          <el-input style="width: 220px;" v-model="modal.url"></el-input>
        </el-form-item>
      </template>
      <template v-if='model==4'>
        <el-form-item label="活动主题">
          <el-input style="width: 220px;" v-model="modal.theme"></el-input>
        </el-form-item>
        <el-form-item label="活动时间">
          <el-input style="width: 220px;" v-model="modal.time" placeholder="请输入时间"></el-input>
        </el-form-item>
        <el-form-item label="活动备注">
          <el-input style="width: 220px;" :rows="4" type="textarea" v-model="modal.remark"></el-input>
        </el-form-item>
      </template>
      <el-form-item label="推送渠道">
         <el-checkbox-group v-model="channel">
          <el-checkbox v-if='model==2 || model==4' :label="9" @change="valueChange(2,$event)">小程序</el-checkbox>
          <el-checkbox v-if='model==1' :label="9">小程序</el-checkbox>
          <el-checkbox v-if='model==3' :label="2" @change="valueChange(3,$event)">服务号</el-checkbox>
          <el-checkbox v-if='model==1' :label="2">服务号</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="跳转链接" v-if='model==1 || model==4'>
        <el-select v-model="modal.linkType" placeholder="请选择"  style="width: 150px;" @change="modal.linkValue == null">
          <el-option
                  v-for="item in options"
                  :key="item.linkType"
                  :label="item.title"
                  :value="item.linkType">
          </el-option>
        </el-select>
        <span v-if="modal.linkType==176 || modal.linkType==179">
          <span style="margin-left: 10px">ID</span>
          <el-input style="width: 150px;" v-model="modal.linkValue" @focus="showTip=false" placeholder="请输入ID"></el-input>
          <span v-if="showTip" class="tip" style="color: red">ID填写错误！</span>
        </span>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="judgmentId">确 定</el-button>
      </span>
  </el-dialog>
</div>
</template>
<script type="text/babel">
import {
  formatDate
} from 'UTILS/date'

const TEMPLATE_MESSAGE_TITLE_LIST = [
  ['活动名称', '活动时间', '活动主题', '备注'],
  ['商品名称', '商品现价', '温馨提示'],
  ['', '主题', '时间', ''],
  ['活动主题', '活动时间', '备注']
]

export default {
  data() {
    return {
      search: {
        page: 1,
        pageSize: 20,
      },
      list: [],
      count: 0,
      isUsingWhiteList: false,
      whiteListUserIds: [],
      canSetWhiteList: false,
      visible: false,
      modal: {
        sendTime: '',
        name: '',
        relatedGroupBuyId: '',
        firstWords: '',
        theme: '',
        time: '',
        lastWords: '',
        url: '',
        goodsName: '',
        goodsPrice: '',
        linkValue:null,
        linkType:175,
        remark:'',
      },
      model: 1,
      channel: [9, 2],
      templateMessage: {
        title: '',
        list: []
      },
      options: [],
      showTip:false,
    }
  },
  watch: {
    visible() {
      this.modal = {
        sendTime: '',
        name: '',
        relatedGroupBuyId: ''
      }
    }
  },
  mounted() {
    this.getList()
  },
  computed: {
    hostName() {
      if (location.href.indexOf("local") > -1 || location.href.indexOf("apitest") > -1) {
        return "https://apitest.ichuanyi.com"
      } else {
        return "https://ichuanyi.com"
      }
    }
  },
  methods: {
    handleCurrentChange(value) {
      if (this.search.page !== value) {
        this.search.page = value
        this.getList()
      }
    },
    showPopover(pushId, model) {
      this.templateMessage = {
        title: '',
        list: []
      }
      HttpRequest.get('/admin.php?method=wechatpusher.getMessageInfo', {pushId: pushId}).then(response => {
        this.templateMessage.title = response.data.title
        this.templateMessage.list = response.data.list.map((item, index) => {
          item.name = TEMPLATE_MESSAGE_TITLE_LIST[model-1] && TEMPLATE_MESSAGE_TITLE_LIST[model-1][index]
          return item
        })
      })
    },
    getList() {
      HttpRequest.get('/admin.php?method=wechatpusher.getList', this.search).then(response => {
        let that = this
        this.list = _.toArray(response.data.list).map((item) => {
          item.status = that.getStatus(item.status)
          item.sendTime = that.getTimeStr(item.sendTime)
          if (item.model == 2) {
            item.sentServiceCount = item.serviceClickCount = item.serviceClickUserCount = '无'
          } else if (item.model == 3) {
            item.miniProgramClickCount = item.miniProgramClickUserCount = item.sentMiniProgramCount = '无'
          }
          return item
        })
        this.count = response.data.count
        this.isUsingWhiteList = response.data.isUsingWhiteList
        this.whiteListUserIds = response.data.whiteListUserIds
        this.canSetWhiteList = response.data.canSetWhiteList
        this.options = response.data.linkList
      })
    },
    changeModel(model) {
      if (model == 2 || model == 4) {
        this.channel = [9]
      } else if (model == 3) {
        this.channel = [2]
      }else {
        this.channel = [9, 2]
      }
    },
    removePush(pushId) {
      this.$confirm('确认删除该推送?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        lockScroll: false
      }).then(() => {
        HttpRequest.post('/admin.php?method=wechatpusher.delete', {
          pushId: pushId
        }).then(response => {
          if (response.data.success) {
            this.$message("删除成功！")
            this.getList()
          }
        })
      }).catch(() => {})
    },
    onCreate(_params) {
      let sendTime = +new Date(this.modal.sendTime) / 1000
      let currTime = +new Date() / 1000
      if (sendTime < currTime) {
        this.$message("推送时间不能小于当前时间")
        return false
      }
      if (this.channel.length == 0) {
        this.$message("请至少选择一个渠道")
        return false
      }
      let params = {
        sendTime: sendTime,
        model: this.model,
        linkType: this.modal.linkType,
        channelList: this.channel
      }
      if(_params){
        params=Object.assign({},params,_params)
      }
      if (this.model == 1) {
        params.name = this.modal.name
        params.relatedGroupBuyId = this.modal.relatedGroupBuyId
        if (!params.sendTime || !params.name.trim() || !params.relatedGroupBuyId.trim() || !params.linkType) {
          this.$message("请填写必填项！")
          return false
        }
      } else if (this.model == 2) {
        params.goodsName = this.modal.goodsName
        params.goodsPrice = this.modal.goodsPrice
        params.relatedGroupBuyId = this.modal.relatedGroupBuyId
      } else if (this.model == 3) {
        params.firstWords = this.modal.firstWords
        params.theme = this.modal.theme
        params.time = this.modal.time
        params.lastWords = this.modal.lastWords
        params.url = this.modal.url
      }else if (this.model == 4) {
        params.theme = this.modal.theme
        params.time = this.modal.time
        params.remark = this.modal.remark

      }
      HttpRequest.post('/admin.php?method=wechatpusher.create', params).then(response => {
        if (response.data.success) {
          this.$message("创建成功！")
          this.visible = false
          this.getList()
        }
      })
    },
    getStatus(status) {
      if (status == 0) {
        return "未推送"
      } else if (status == 1) {
        return "推送中"
      } else if (status == 2) {
        return "已推送"
      }
    },
    getTimeStr(time) {
      return formatDate(time, 'yyyy-MM-dd hh:mm')
    },
    valueChange(model,checked){
      if(!checked && (model === 2 || model === 4)){
        this.channel=[9]
      }
      if(!checked && model === 3){
        this.channel=[2]
      }
    },
    judgmentId(){
      if(this.modal.linkType==176 || this.modal.linkType==179){
        let params={
          linkType:this.modal.linkType,
          linkValue:this.modal.linkValue
        }
        if(!params.linkValue){
          this.$message("请填写Id！")
          return false;
        }
        HttpRequest.post('/admin.php?method=wechatpusher.checkLinkTypeUseID', params).then(response => {
          if (response.data.success) {
            this.onCreate({linkValue:this.modal.linkValue})
          }else{
            this.$message("ID号填写错误！")
            this.showTip=true
            return false
          }
        })
      }else{
        this.onCreate()
      }
    }
  }
}
</script>
<style lang="less" scoped>
td {
    text-align: center;
}
.template-message {
  .content {
    padding-left: 20px;
    span {
      vertical-align: top;
      margin-right: 10px;
    }
  }
}
textarea {
    border: 0;
    width: 184px;
    height: 210px;
}
</style>
